/* FileExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
//const FileServerStatusComponent = require("./views/file_server_status/FileServerStatusComponent");
const _ = require("lodash");

class FileExplorerLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        solutionManager,
        OsImageServerEntity,
        storageFactory
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._solutionManager = solutionManager;
        this._OsImageServerEntity = OsImageServerEntity;
        this._storageFactory = storageFactory;
        this._updateNameSpaces();

        this._activeOrgId = _.get(this._userSession, "activeOrganization.id");
        this._imageServersFeed = this._establishImageServersFeed(this._activeOrgId);
        this._statusBar = this._initStatusBar();

        this._registerFileExplorerListeners();
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._emptyFilter = false;
        let superRender = this.renderer.render;
        this.renderer.render = (args) => {
            this._statusBar.render();
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer.rootElement.classList.add("file-explorer-lmrb");

                let otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                    this._openEditorFromUrl = {
                        open: otherParams.openEditor || false,
                        selectedIds: otherParams.selection,
                    };
                }
                if (!_.isEmpty(otherParams.filter)) {
                    this._filterFromUrl = true;
                }
                if (_.isEmpty(otherParams.filter) && !_.isUndefined(otherParams.filter)) {
                    this._emptyFilter = true;
                }

                this.renderer.rootElement
                    .querySelector("game-editor-view-actions-gl left-container")
                    .appendChild(this._statusBar.rootElement);
            });
        };
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "fileExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "fileExplorer.actionNamespaces", []);

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _registerFileExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        //this._cabinetCmpnt.on("ViewSelected", this._initStatusBar.bind(this));
    }

    _registerImageServersFeedListeners(feed) {
        const onFeedUpdate = _.debounce(this._onImageServerFeedUpdate.bind(this), 0);
        feed.on("ChangeFeedInitialized", (data, feed /*, reInit*/) => {
            onFeedUpdate(feed, "ChangeFeedInitialized");
        })
            .on("EntityInitialized", () => {
                onFeedUpdate(feed, "EntityInitialized");
            })
            .on("EntityPropertiesUpdated", (entity, patches, props, feed) => {
                onFeedUpdate(feed, "EntityPropertiesUpdated");
            })
            .on("EntityAdded", (entity, properties, feed) => {
                onFeedUpdate(feed, "EntityAdded");
            })
            .on("EntityRemoved", (entity, cause, feed) => {
                onFeedUpdate(feed, "EntityRemoved");
            })
            .once("ShutdownStarted", () => {
                onFeedUpdate.cancel();
                feed.removeListener("ChangeFeedInitialized", onFeedUpdate)
                    .removeListener("EntityInitialized", onFeedUpdate)
                    .removeListener("EntityPropertiesUpdated", onFeedUpdate)
                    .removeListener("EntityAdded", onFeedUpdate)
                    .removeListener("EntityRemoved", onFeedUpdate);
            });
    }

    _unregisterFileExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
    }

    launchFileEditor(editorState, launchOpts) {
        const {imageIds} = launchOpts;
        this.generateHash(imageIds)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    imageId: imageIds[0],
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.FILE_INSTANCE_EDITOR,
                    launchOpts
                );
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    _establishImageServersFeed(orgId) {
        if (!orgId) {
            return;
        }
        const query = {};
        const fields = [
            "enabled",
            "name",
            "identifier",
            "ip",
            "status",
            "percentFull",
            "isMain",
        ].reduce((fields, field) => Object.assign(fields, {[field]: true}), {});

        const sort = {createdOn: 1};
        if (this._imageServersFeed) {
            this._imageServersFeed
                .whenInitialized()
                .then(() => this._imageServersFeed.reestablishFeed(orgId, query, fields, sort));
        } else {
            this._imageServersFeed = this._OsImageServerEntity.startAscendOsImageServersFeed(
                orgId,
                query,
                fields,
                sort
            );
            this._registerImageServersFeedListeners(this._imageServersFeed);
        }

        return this._imageServersFeed;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        let shutdowns = [
            _.invoke(this._statusBar, "shutdown"),
            _.invoke(this._imageServersFeed, "shutdown"),
        ];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterFileExplorerListeners();
                this._editorLayout = undefined;
                this._userSession = undefined;
                this._solutionManager = undefined;
                this._openEditorFromUrl = undefined;
                this._filterFromUrl = undefined;
                this._emptyFilter = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "OSPlanExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _initStatusBar() {
        let diOpts = _.cloneDeep(this._defaultDiOpts);
        diOpts.injectableOverrides = {
            "gameEditor.gameEditor": this,
        };
        return this._di.createInstance(Registrations.FILE_EXPLORER_STATUS_BAR, diOpts);
    }

    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.FILE_EXPLORER_LMRB)
        // ) {
        //     this._updateNameSpaces(true);
        //     this.renderer.render();
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange({id}) {
        if (id !== this._activeOrgId) {
            this._activeOrgId = id;
            this._establishImageServersFeed(id);
            this.renderer.render();
        }
    }

    _onImageServerFeedUpdate(feed) {
        this.emit("ImageServersUpdated", feed.getCacheAsArray());
    }

    toggleGameEditorActions(actionRegName, state) {
        return state ? this.showBarAction(actionRegName) : this.hideBarAction(actionRegName);
    }
}

module.exports = FileExplorerLmrbComponent;

FileExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.solutionsManager",
    "$teve.entities.OsImageServer",
    "$teve.storageFactory",
];
FileExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
FileExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
FileExplorerLmrbComponent.$iconRepoName = "fileserver.file_explorer";
FileExplorerLmrbComponent.$openedByDefault = true;
FileExplorerLmrbComponent.$displayName = "File Explorer";
